export default __webpack_public_path__ + "static/media/rain_night.e93af056.svg";